package kz.dentalcrm.app.expectations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf

internal class ContactPickerStateImpl(
    private val contactPicked: (UserPhone?) -> Unit,
) : ContactPickerState {

    private var _value: MutableState<UserPhone?> = mutableStateOf(null)

    override val value: State<UserPhone?> get() = _value

    private val contactPicker = ContactPicker()

    @Composable
    override fun initContactPicker() {
        contactPicker.registerContactPicker {
            _value.value = it
            contactPicked(it)
        }
    }

    override fun launchContactPicker() {
        contactPicker.launchContactPicker()
    }
}